<div class="row mt-5 ml-5 mr-5 padding" style="justify-content: center;">
<div class="col-md-4 p-2 link-cursor" *ngFor="let kpi of kpiData">    
    <mat-card class="card card3 w-100 m-0 p-2" [ngStyle]="{'background-color': kpi.kpiConfiguration.backgroundColor}">
      <div class="spaceBtwn px-2 col-md-12">
        <div class="d-flex font14">
            <img [src]="getImageUrl(kpi.kpiConfiguration.kpiDetails.kpiImage)" class="cardicon zoom" alt="{{kpi.kpiConfiguration.displayText}}">
            {{ kpi.kpiConfiguration.displayText }}
        </div>
        <div class="cardlbl">
          {{ kpi.stats }}
        </div>
      </div>
    </mat-card>
  </div>
</div>